import {Label, LabelOff} from "@mui/icons-material";
import {ListItemText, MenuItem} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import {MouseEventHandler, useContext, useMemo} from "react";
import { connect } from "react-redux";
import { selectProject } from "../../redux/selectors/editor";
import { selectConstants, selectTags } from "../../redux/selectors/firebase";
import { getConstant, getRemoveableTags, getTagDisplayValue } from "../../utility/constantsTagsUtils";
import NestedMenuItem from "../../utility/NestedMenuItem";
import { FirebaseContext } from "../firebase/FirebaseProvider";
import { Constants, Tags } from "../graph/StateTags";
import {intrinsics} from "../dialogs/project/ConstantStyle";

const useStyles = makeStyles((theme) => ({
    item: {
        marginRight: theme.spacing(1)
    }
}));

interface Props
{
    tags: Tags
    constants: Constants
    project: string
    parentOpen: boolean
    selection: string[]
    setAddTagType: (type: string) => void
    onClose: () => void
}

function AddRemoveNodeTagMenuItem({ tags, parentOpen, project, constants, selection, setAddTagType, onClose }: Props)
{
    const classes = useStyles();
    const { remove } = useContext(FirebaseContext);
    const removableTags = useMemo(() => getRemoveableTags(tags, selection), [tags, selection]);
    const previousTagType = localStorage.getItem("addTagDialog.lastType");
    const previousTagConstant = previousTagType !== null && constants[previousTagType];
    const previousTagValue = previousTagConstant && previousTagConstant.type !== "date" ?
        localStorage.getItem("addTagDialog.lastValue") : "";
    const previousTag = `${previousTagType || ""} ${previousTagValue}`;
    const handleAddTag: MouseEventHandler<HTMLElement> = ({currentTarget}) => {
        setAddTagType(currentTarget?.dataset?.type ?? "");
    }
    const handleAddPreviousTag = () => {
        setAddTagType(localStorage.getItem("addTagDialog.lastType") ?? "");
    };
    const handleRemoveTagFromSelection: MouseEventHandler<HTMLElement> = ({currentTarget}) =>
    {
        const { type, value } = JSON.parse(currentTarget.dataset.tag as string);

        if (tags)
        {
            selection.forEach((state) =>
            {
                const tagEntry = Object.entries(tags[state] ?? {}).find(([id, tag]) => tag.type === type && tag.value === value);

                if (tagEntry)
                {
                    const [id] = tagEntry;
                    remove(`tags/${project}/${state}/${id}`).catch(console.error);
                }
            });
        }

        onClose();
    }

    return <>
        {previousTagConstant &&
            <MenuItem disabled={!localStorage.getItem("addTagDialog.lastType")} onClick={handleAddPreviousTag}>
                <>
                    <Label className={classes.item} fontSize="small"/>
                    <ListItemText>{`Add ${previousTag}`}</ListItemText>
                </>
            </MenuItem>
        }
        <NestedMenuItem disabled={Object.keys(constants).length === 0} parentOpen={parentOpen} label={
            <><Label className={classes.item} fontSize="small" />Add Node Tag</>
        }>
            {Object.entries(constants ?? [])
                .filter(([id]) => ! intrinsics[id])
                .map(([id, constant]) =>
                    <MenuItem key={`addTag${id}`} data-type={id} onClick={handleAddTag}>
                        <ListItemText>{constant.name}...</ListItemText>
                    </MenuItem>
            )}
        </NestedMenuItem>
        <NestedMenuItem disabled={Object.keys(constants).length === 0 || removableTags.length === 0} parentOpen={parentOpen} label={
            <><LabelOff className={classes.item} fontSize="small" />Remove Node Tag</>
        }>
            {constants && removableTags.map((tag, index) =>
            {
                return <MenuItem key={`removeTag${index}`} data-tag={JSON.stringify(tag)} onClick={handleRemoveTagFromSelection}>
                    <ListItemText>
                        {`${getConstant(tag.type, constants)?.name}: ${getTagDisplayValue(tag, constants)}`}
                    </ListItemText>
                </MenuItem>
            })}
        </NestedMenuItem>
    </>
}

const mapStateToProps = (store: never) => ({
    project: selectProject(store),
    constants: selectConstants(store) || {},
    tags: selectTags(store)
});
export default connect(mapStateToProps, {
})(AddRemoveNodeTagMenuItem);